import { Component, OnInit } from '@angular/core';
import {MdDialog,MdSnackBar} from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-feedback-sent-to',
  templateUrl: './feedback-sent-to.component.html',
  styleUrls: ['./feedback-sent-to.component.css']
})
export class FeedbackSentToComponent implements OnInit {
  feedbacks : any;
  nameArray: any;
  errorMessage: any;
  spinner: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,private snackBar: MdSnackBar) { }

 ngOnInit() {
   
  }

 
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/profile/feedback-sent-to/feedback-sent-to.component.ts